<template>
  <el-empty class="ListEmpty" :description="$t('public.emptyData')" :image-size="size">
    <template #image>
      <img :src="targetSrc" class="w-68">
    </template>
  </el-empty>
</template>

<script setup>
import EmptyPopularImage from 'image/empty/popular.webp'
const emit = defineEmits()
const props = defineProps({
  size: {},
  name: {
    default: 'popular'
  }
})

const srcMap = {
  popular: EmptyPopularImage
}

const targetSrc = $computed(() => srcMap[props.name])

onBeforeMount(() => {})
</script>

<style lang="scss">
@use "sass:math";
@use "sass:map";
@import "@/sass/var/index.scss";

.ListEmpty {
  .el-empty__description{
    margin-top: 15px;
    line-height: normal;
    --el-text-color-secondary: #{$color-info};
    color: $color-info !important;
  }
}
</style>
